import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "offset-y": "",
    "close-on-content-click": "",
    value: _ctx.menuOpen,
    location: "bottom"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn_icon, _mergeProps({
        density: "compact",
        icon: "$more_vert"
      }, props), null, 16)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createVNode(_component_v_list, {
        flat: "",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "prepend-list-items", {}, undefined, true),
          (!_ctx.isOptionHidden('edit'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                onClick: _ctx.emitEditBtnClicked,
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("$fa-gear")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Editer")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('clone'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                onClick: _ctx.emitDuplicationBtnClicked,
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("$fa-clone")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Dupliquer")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('visible'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 2,
                onClick: _ctx.emitVisibilityBtnClicked,
                density: "compact"
              }, {
                append: _withCtx(() => [
                  (_ctx.box == null)
                    ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("$oss-eye")
                        ])),
                        _: 1
                      }))
                    : (_ctx.box.visible)
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("$oss-eye-slash")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("$oss-eye")
                          ])),
                          _: 1
                        }))
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      (_ctx.box == null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Cacher / Afficher"))
                        : (_ctx.box.visible)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Cacher"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, "Afficher"))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('front'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 3,
                onClick: _withModifiers(_ctx.emitMoveToFrontClicked, ["stop"]),
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("$fa-step-forward")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Mettre en avant")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('back'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 4,
                onClick: _withModifiers(_ctx.emitMoveToBackClicked, ["stop"]),
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("$fa-step-backward")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Mettre en arrière")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('forward'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 5,
                onClick: _withModifiers(_ctx.emitMoveForwardClicked, ["stop"]),
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("$fa-forward")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Vers l'avant")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('backward'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 6,
                onClick: _withModifiers(_ctx.emitMoveBackwardClicked, ["stop"]),
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("$fa-backward")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("Vers l'arrière")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isOptionHidden('delete'))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 7,
                onClick: _ctx.emitDeletionBtnClicked,
                density: "compact"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("$oss-trash")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Supprimer")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "append-list-items", {}, undefined, true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["value"]))
}